/* Weslora — lightweight progressive enhancement. No dependencies. */
(function () {
  'use strict';
  window.wslReady = true;

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var observer = null;

  function reveal(root) {
    var items = (root || document).querySelectorAll('.wsl-reveal:not(.is-in)');
    if (!items.length) return;
    if (reduceMotion || !('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    if (!observer) {
      observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-in');
            observer.unobserve(entry.target);
          }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
    }
    items.forEach(function (el) { observer.observe(el); });
  }

  function gallery(root) {
    (root || document).querySelectorAll('[data-wsl-gallery]').forEach(function (wrap) {
      if (wrap.dataset.wslReady) return;
      wrap.dataset.wslReady = '1';
      var slides = wrap.querySelectorAll('[data-wsl-slide]');
      var thumbs = wrap.querySelectorAll('[data-wsl-thumb]');
      thumbs.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var i = btn.getAttribute('data-wsl-thumb');
          slides.forEach(function (s) { s.hidden = s.getAttribute('data-wsl-slide') !== i; });
          thumbs.forEach(function (t) { t.setAttribute('aria-current', t === btn ? 'true' : 'false'); });
        });
      });
    });
  }

  function expanders(root) {
    (root || document).querySelectorAll('[data-wsl-expand]').forEach(function (btn) {
      if (btn.dataset.wslReady) return;
      btn.dataset.wslReady = '1';
      var target = document.getElementById(btn.getAttribute('aria-controls'));
      if (!target) return;
      var labelMore = btn.getAttribute('data-label-more');
      var labelLess = btn.getAttribute('data-label-less');
      btn.addEventListener('click', function () {
        var open = target.classList.toggle('is-expanded');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        btn.querySelector('[data-wsl-label]').textContent = open ? labelLess : labelMore;
      });
    });
  }

  function init(root) {
    reveal(root);
    gallery(root);
    expanders(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  // Theme editor support: re-run when a section is added or re-rendered.
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var el = e.target.closest ? e.target.closest('.wsl-reveal') : null;
    if (el) el.classList.add('is-in');
  });
})();
